module.exports = __webpack_public_path__ + "img/colorStarIcon.19e62549.svg";